module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "_about",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageiv",
      "title": "iv"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "drop",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v(" A")]), _vm._v("nna Franklin is a third-degree witch and high priestess of    the Hearth of Arianrhod, and she has been a practicing Pagan for more than forty years. She is the author of thirty books and the creator of the "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Sacred Circle Tarot")]), _vm._v(", "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Fairy Ring Oracle")]), _vm._v(", and the "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Pagan Ways Tarot")]), _vm._v(" (Schiffer, 2015). Her books have been translated into nine languages. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Anna has contributed hundreds of articles to Pagan magazines and has appeared on radio and TV. She lives and works in a village in the English Midlands, where she grows her own herbs, fruit, and vegetables, and generally lives the Pagan life. Visit her online at ")]), _c('span', {
    staticClass: "link",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("www.AnnaFranklin.co.uk")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1801f507","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 57
// module chunks = 0